import styled from "styled-components";
import { Button } from "../../../components/Button";
import { Flex } from "../../../components/Flex";
import { useTranslation } from "react-i18next";

const SubmitButton = styled(Button)`
  height: 2.3rem;
  width: fit-content;
  margin: 0;

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.darkMain};
  }
`;

const CancelButton = styled(Button)`
  height: 2.3rem;
  width: 7rem;
  margin: 0;
  background-color: ${({ theme }) => theme.transparent};
  color: ${({ theme }) => theme.main};
  border: 1px solid ${({ theme }) => theme.main};

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.main};
    color: white;
  }
`;

type Props = {
  onSubmit: VoidFunction;
  submitTitle?: string;
  onCancel?: VoidFunction;
  config?: {
    loading?: boolean;
    disabled?: boolean;
    editMode?: boolean;
    hideCancelButton?: boolean;
  };
  cancelTestId?: string;
  submitTestId?: string;
};

export const DrawerDefaultsExtra: React.FC<Props> = ({
  onSubmit,
  onCancel,
  submitTitle,
  config,
  cancelTestId,
  submitTestId,
}) => {
  const { t } = useTranslation();

  return (
    <Flex gap="s">
      {config?.hideCancelButton ? null : (
        <CancelButton
          title={t("common.cancel")}
          hover
          onClick={onCancel}
          disabled={config?.loading || false}
          dataTestId={cancelTestId}
        />
      )}
      <SubmitButton
        title={
          submitTitle ||
          (config?.editMode ? t("common.edit") : t("common.create"))
        }
        hover
        onClick={onSubmit}
        loading={config?.loading || false}
        disabled={config?.disabled || config?.loading || false}
        dataTestId={submitTestId}
      />
    </Flex>
  );
};
